import { render } from "./PunchCardsView.vue?vue&type=template&id=5022f27f&scoped=true&ts=true"
import script from "./PunchCardsView.vue?vue&type=script&lang=ts"
export * from "./PunchCardsView.vue?vue&type=script&lang=ts"

import "./PunchCardsView.vue?vue&type=style&index=0&id=5022f27f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5022f27f"]])

export default __exports__